import { Routes } from '@angular/router';
import { CommonConstants } from './common/utilities/commonConstants';
import { HomeComponent } from './home/home.component';
import { ConfigResolve } from './common/services/config.resolve.service';
import { OtpResumeApplicationComponent } from './otpResumeApplication/otpResumeApplication.component';
import { ExistingCustomerComponent } from './existingCustomer/existingCustomer.component';
import { CustomerLoginComponent } from './customerLogin/customerLogin.component';
import { MultitabFailedComponent } from './multitabFailed/multitabFailed.component';
import { OTPVerificationComponent } from './emiOtpVerification/emiOtpVerification.component';
import { PaymentFailedComponent } from './finalModule/paymentFailed/paymentfailed.component';
import { PaymentStatusComponent } from './payment-status/payment-status.component';
import { CongratulationsComponent } from './finalModule/congratulations/congratulations.component';
import { GetGoingComponent } from './getGoingNow/getGoingNow.component';
import { AuthGuard } from './common/utilities/authGuard';

export const ROUTES: Routes = [
    { path: '', component: GetGoingComponent, resolve: { config: ConfigResolve }, canActivate: [AuthGuard] },
    {
        path: CommonConstants.Routes.Home,
        component: HomeComponent,
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.Application.GetGoingNow,
        component: GetGoingComponent,
        resolve: { config: ConfigResolve },
        // AuthGaurd
        canActivate: [AuthGuard]
    },
    {
        path: CommonConstants.Routes.Application.GetGoingNowEdit,
        component: GetGoingComponent,
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.Application.PaymentFailed,
        component: PaymentFailedComponent,
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.Application.Congratulations,
        component: CongratulationsComponent,
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.ResumeApplication,
        component: OtpResumeApplicationComponent,
        resolve: { config: ConfigResolve },
    },
    {
        path: CommonConstants.Routes.ApplicationList,
        component: ExistingCustomerComponent,
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.CustomerLogin,
        component: CustomerLoginComponent,
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.otp,
        component: OTPVerificationComponent,
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.MultitabFailed,
        component: MultitabFailedComponent,
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.Application.InsPolicyPage,
        component: CongratulationsComponent,
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.Application.RetryPaymentPage,
        component: PaymentFailedComponent,
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.Application.PaymentStatus,
        component: PaymentStatusComponent,
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.Application.PendingPaymentPage,
        component: PaymentFailedComponent,
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.ApplicationModule.PlanDetail,
        loadChildren: () =>
            import('./applicationModule/application.module').then((m) => m.ApplicationModule),
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.DetailsModule.ProposerPersonalDetails,
        loadChildren: () =>
            import('./detailsModule/details.module').then((m) => m.DetailsModule),
        resolve: { config: ConfigResolve }
    }, {
        path: CommonConstants.Routes.InsuredModule.InsurerDetails,
        loadChildren: () =>
            import('./insurerDetailModule/insurer.module').then((m) => m.InsurerModule),
        resolve: { config: ConfigResolve }
    },
    {
        path: CommonConstants.Routes.Verification.Home,
        loadChildren: () =>
            import('./verificationModule/verification.module').then((m) => m.VerificationModule),
        resolve: { config: ConfigResolve }
    }, {
        path: CommonConstants.Routes.FinalModule.ProductReview,
        loadChildren: () =>
            import('./finalModule/final.module').then((m) => m.FinalModule),
        resolve: { config: ConfigResolve }
    }, {
        path: CommonConstants.Routes.QuestionnaireModule.MoreAboutYou,
        loadChildren: () =>
            import('./questionnaireModule/questionnaire.module').then((m) => m.QuestionnaireModule),
        resolve: { config: ConfigResolve }
    },
];
